export const languages = {
  'zh-TW': '繁體中文',
  'en': 'English',
  'ja': '日本語'
};

export const translations = {
  'zh-TW': {
    // Navigation
    hero: '鑽石之美',
    mine: '鑽石礦場',
    grading: '分級評估',
    cutting: '切割拋光',
    certification: '認證',
    journey: '客戶之旅',
    conclusion: '您的鑽石之旅',

    // Hero Section
    heroTitle: '永恆璀璨',
    heroSubtitle: '之旅',
    heroDescription: '探索從原石到閃耀珠寶的非凡旅程。每一顆鑽石都訴說著億萬年的故事。',
    beginJourney: '開始您的旅程',

    // Mine Section
    mineTitle: '鑽石礦場',
    mineDescription: '在地球表面深處，大自然最珍貴的寶藏等待著被發現。探索鑽石開採的迷人世界。',
    extraction: '開採',
    extractionDesc: '使用先進的開採技術從地球深處提取鑽石。',
    extractionDetails: '露天開採和地下開採方法用於到達含鑽石的礦石沉積物。',
    processing: '處理',
    processingDesc: '原礦石經過處理，將鑽石從周圍的岩石和礦物中分離出來。',
    processingDetails: 'X射線技術和重介質分離有助於識別和提取鑽石。',
    recovery: '回收',
    recoveryDesc: '先進技術確保從處理過的礦石中最大限度地回收鑽石。',
    recoveryDetails: '先進的分選系統可以檢測到小至1毫米直徑的鑽石。',
    didYouKnow: '您知道嗎？',
    diamondFormation: '鑽石在地球表面以下100-200公里處，在極高的壓力和溫度下形成。天然鑽石的形成需要數十億年的時間！',
    nextSorting: '下一步：分級評估',

    // Earth Layers
    surfaceLayer: '地表層',
    continentalCrust: '大陸地殼',
    upperMantle: '上地幔',
    lowerMantle: '下地幔',
    coreMantle: '核幔邊界',

    // Grading Section
    gradingTitle: '鑽石4C標準',
    gradingDescription: '了解決定鑽石品質和價值的四個特徵。',
    exploreCharacteristics: '探索每個特徵',
    cut: '切工',
    cutDesc: '切工決定鑽石反射光線的能力，影響其光彩和火彩。',
    clarity: '淨度',
    clarityDesc: '淨度衡量鑽石中內含物和瑕疵的缺失程度。',
    color: '顏色',
    colorDesc: '顏色等級評定鑽石的無色程度，D級為完全無色。',
    carat: '克拉',
    caratDesc: '克拉衡量鑽石的重量，一克拉等於200毫克。',
    gradingScale: '等級標準：',
    testKnowledge: '測試您的知識',
    testDescription: '看看您對4C標準的了解程度！',
    quizComplete: '測驗完成！',
    yourScore: '您的得分',
    correctAnswers: '正確答案：',
    greatJob: '恭喜您學習了鑽石品質知識！',
    nextCutting: '下一步：切割拋光',

    // Quiz Questions
    quiz1: '哪個「C」對鑽石的閃耀度影響最大？',
    quiz1Options: ['切工', '顏色', '淨度', '克拉'],
    quiz2: '鑽石淨度中的「FL」代表什麼意思？',
    quiz2Options: ['有瑕疵', '無瑕疵', '一般光澤', '精細光澤'],
    quiz3: '哪個顏色等級代表完全無色的鑽石？',
    quiz3Options: ['A', 'D', 'F', 'Z'],

    // Cutting Section
    cuttingTitle: '切割與拋光',
    cuttingDescription: '通過精密切割和拋光將粗糙鑽石轉化為璀璨寶石的藝術。',
    interactiveDiamond: '互動鑽石',
    adjustQuality: '調整切工品質以查看對光彩的影響',
    cutQuality: '切工品質',
    diamondShapes: '鑽石形狀',
    brilliance: '光彩',
    poor: '差',
    fair: '一般',
    good: '良好',
    veryGood: '很好',
    excellent: '優秀',

    // Fixed descriptions for consistent layout
    poorDesc: '光線洩漏嚴重，閃耀度極低',
    fairDesc: '部分光線回射，閃耀度適中',
    goodDesc: '良好光線回射，閃耀度佳',
    veryGoodDesc: '優異光線回射，閃耀明亮',
    excellentDesc: '最佳光線回射，閃耀卓越',

    cuttingProcess: '切割過程',
    planning: '規劃：分析粗糙鑽石以最大化產量',
    cleaving: '劈裂：沿著天然紋理線分裂鑽石',
    shaping: '成形：創建最終形狀的基本輪廓',
    polishing: '拋光：創建精確切面以獲得最大光彩',
    nextCertification: '下一步：認證',

    // Certification Section
    certificationTitle: '鑽石認證',
    certificationDescription: '獨立驗證確保您的鑽石投資的品質、真實性和價值。',
    gradingReport: '鑽石分級報告',
    certificateNumber: '證書編號',
    verified: '已驗證',
    diamondDetails: '鑽石詳情',
    measurements: '測量數據',
    shape: '形狀',
    caratWeight: '克拉重量',
    colorGrade: '顏色等級',
    clarityGrade: '淨度等級',
    cutGrade: '切工等級',
    dimensions: '尺寸',
    table: '台面',
    depth: '深度',
    girdle: '腰圍',
    fluorescence: '螢光性',
    certificateGuarantee: '此證書保證您鑽石的真實性和品質',
    trustedBodies: '可信認證機構',
    faq: '常見問題',
    nextJourney: '下一步：客戶之旅',

    // Journey Section
    journeyTitle: '抵達您心中',
    journeyDescription: '從我們手中到您手中 - 每顆鑽石都承載著愛情、承諾和夢想成真的故事。',
    diamondJourney: '您鑽石的旅程',
    orderConfirmation: '訂單確認',
    orderConfirmed: '您的訂單已確認並正在準備中',
    qualityInspection: '品質檢驗',
    finalCheck: '最終品質檢查和安全包裝',
    shipped: '已發貨',
    onWay: '您的鑽石正在運送途中',
    delivered: '已送達',
    arrives: '您珍貴的鑽石安全抵達',
    storiesOfLove: '愛的故事',
    moreThanDiamond: '不僅僅是一顆鑽石',
    moreThanDescription: '我們交付的每一顆鑽石都承載著永恆的承諾。從離開我們手中的那一刻到到達您手中的那一刻，它不僅僅是一塊珍貴的石頭 - 它是愛情、承諾和您獨特故事開始的象徵。',
    satisfactionGuarantee: '滿意保證',
    lifetimeSupport: '終身關懷與支持',
    foreverMemories: '永恆回憶',
    completeJourney: '完成您的旅程',
    
    // Ginza Diamond Shiraishi translations
    ginzaDiamondTitle1: '實惠的價格，高品質的鑽石',
    ginzaDiamondContent1: 'GINZA DIAMOND SHIRAISHI 銀座白石 透過自家嚴格的篩選與採購系統，從世界三大鑽石市場（印度、以色列、比利時）中，精選世界頂級美鑽，並確保以合理價格提供給顧客。我們擁有常備18,000顆以上的鑽石，每一顆都經過嚴格檢查，包括切割角度、透明度等細節，遠超過傳統4C標準，確保展現出超越鑑定書所能衡量的璀璨光芒。',
    ginzaDiamondContent2: '自創立以來，GINZA DIAMOND SHIRAISHI 銀座白石 始終堅持提供適合作為人生重要時刻的「第一手鑽石（Virgin Diamond）」，以及擁有世界頂級光輝的美鑽。我們始終不懈追求最高品質，並將這份堅持傳遞給每一對新人，讓他們的幸福時刻更加閃耀動人。',
    ginzaDiamondTitle2: '「第一手鑽石」的堅持',
    ginzaDiamondContent3: 'GINZA DIAMOND SHIRAISHI 銀座白石 直接從世界三大鑽石市場（印度、以色列、比利時）的原石持有者手中採購鑽石原石，並委託專屬研磨工廠進行精密切割與打磨。所有鑽石皆經過嚴格篩選，並由品牌獨立負責從採購到銷售的一站式經營。我們始終堅持提供「第一手鑽石（Virgin Diamond）」，確保其擁有世界最高等級的璀璨光輝。',
    ginzaDiamondContent4: '透過這樣的一站式經營，我們確保所有鑽石並非「衝突鑽石（Conflict Diamonds）」，並且絕非「二手鑽石（Reuse Diamonds）」或「重新切割的鑽石（Recycled Diamonds）」，所有鑽石皆符合「金伯利進程認證制度（Kimberley Process Certification Scheme）」，是真正純淨無瑕的第一手鑽石。這種與眾不同、獨特的鑽石採購機制，GINZA DIAMOND SHIRAISHI 銀座白石 能夠提供從未經過他人佩戴、真正屬於新人們的高品質第一手鑽石。我們密切關注全球市場趨勢、經濟環境與匯率變動，確保以最合理的價格，為每一對新人提供最優質的鑽石，讓他們的愛情故事閃耀純粹光輝。這正是GINZA DIAMOND SHIRAISHI 銀座白石 最自豪的品牌承諾與堅持。',
    ginzaDiamondTitle3: '嚴格篩選每一顆鑽石，精心採購',
    ginzaDiamondContent5: '從世界三大鑽石市場（印度、以色列、比利時）精選採購經過精密研磨的鑽石，並透過Sarine Light系統逐一測量其光輝表現。我們僅挑選符合買手嚴格標準並達到最高評價Ultimate的頂級鑽石，確保每一顆皆擁有極致璀璨的光芒。',
    ginzaDiamondTitle4: '第一手鑽石證書',
    ginzaDiamondContent6: 'GINZA DIAMOND SHIRAISHI 銀座白石 希望每位顧客都能安心選擇鑽石，因此特別提供「第一手鑽石證書（Virgin Diamond Certificate）」。',
    ginzaDiamondContent7: '在當今國際情勢影響下，「第一手鑽石」已不再是理所當然的選擇。然而，GINZA DIAMOND SHIRAISHI 銀座白石 所提供的鑽石，不僅確保絕非「衝突鑽石」，更嚴格保證不使用「二手鑽石」或「重新切割的鑽石」，每一顆皆為珍貴且純淨的第一手鑽石。透過這份證明，我們承諾為顧客提供真正稀有、純淨無瑕的鑽石，讓每一對新人都能擁有屬於他們人生中最重要時刻的珍貴光輝。',

    // Conclusion Section
    conclusionTitle: '開始您的故事',
    conclusionDescription: '您的鑽石之旅從這裡開始。讓我們幫助您找到完美的愛情故事象徵，它將為後代閃耀。',
    exploreCollection: '求婚戒指',
    browseSelection: '為了讓兩人的愛情永恆閃耀，提供最高品質的頂級鑽石。在銀座白石遇見您生命中獨一無二的命定鑽石。',
    shopNow: '前往挑選心儀戒指',
    bookConsultation: '結婚戒指',
    meetExperts: '婚後日常生活中需長時間配戴的婚戒，舒適度和耐用性是銀座白石不斷追求以及鑽研的工法',
    scheduleNow: '前往挑選心儀戒指',
    customDesign: '對戒',
    createUnique: '銀座白石的套戒，為了能符合日常生活中的配戴，彷彿就像一個套組的整體感設計。',
    startDesigning: '前往挑選心儀戒指',
    stayConnected: '保持聯繫',
    exclusiveAccess: '獲得新收藏、鑽石教育和特別優惠的獨家訪問權。',
    subscribeNewsletter: '訂閱電子報',
    thankYouSubscribing: '感謝您的訂閱！',
    receiveUpdates: '您很快會收到我們的最新消息。',
    getInTouch: '聯繫我們',
    shareJourney: '分享您的旅程',
    thankYouJoining: '感謝您加入我們的旅程',
    finalMessage: '從地球深處到您眼中的光芒，每顆鑽石都承載著時間、壓力和轉變的故事。現在是時候創造您自己的故事了。'
  },
  'en': {
    // Navigation
    hero: 'The Beauty of Diamonds',
    mine: 'The Diamond Mine',
    grading: 'Sorting and Grading',
    cutting: 'Cutting and Polishing',
    certification: 'Certification',
    journey: 'Journey to Customer',
    conclusion: 'Your Diamond Journey',

    // Hero Section
    heroTitle: 'The Journey of',
    heroSubtitle: 'Eternal Brilliance',
    heroDescription: 'Discover the extraordinary journey from rough stone to sparkling treasure. Each diamond tells a story billions of years in the making.',
    beginJourney: 'Begin Your Journey',

    // Mine Section
    mineTitle: 'The Diamond Mine',
    mineDescription: 'Deep beneath the Earth\'s surface, nature\'s most precious treasures await discovery. Explore the fascinating world of diamond mining.',
    extraction: 'Extraction',
    extractionDesc: 'Diamonds are extracted from deep within the Earth using advanced mining techniques.',
    extractionDetails: 'Open-pit and underground mining methods are used to reach diamond-bearing ore deposits.',
    processing: 'Processing',
    processingDesc: 'Raw ore is processed to separate diamonds from surrounding rock and minerals.',
    processingDetails: 'X-ray technology and dense media separation help identify and extract diamonds.',
    recovery: 'Recovery',
    recoveryDesc: 'Advanced technology ensures maximum diamond recovery from processed ore.',
    recoveryDetails: 'Sophisticated sorting systems can detect diamonds as small as 1mm in diameter.',
    didYouKnow: 'Did You Know?',
    diamondFormation: 'Diamonds are formed 100-200 kilometers below the Earth\'s surface under extreme pressure and temperature. It takes billions of years for a diamond to form naturally!',
    nextSorting: 'Next: Sorting & Grading',

    // Earth Layers
    surfaceLayer: 'Surface Layer',
    continentalCrust: 'Continental Crust',
    upperMantle: 'Upper Mantle',
    lowerMantle: 'Lower Mantle',
    coreMantle: 'Core-Mantle Boundary',

    // Grading Section
    gradingTitle: 'The 4Cs of Diamonds',
    gradingDescription: 'Understanding the four characteristics that determine a diamond\'s quality and value.',
    exploreCharacteristics: 'Explore Each Characteristic',
    cut: 'Cut',
    cutDesc: 'The cut determines how well a diamond reflects light, affecting its brilliance and sparkle.',
    clarity: 'Clarity',
    clarityDesc: 'Clarity measures the absence of inclusions and blemishes in the diamond.',
    color: 'Color',
    colorDesc: 'Color grades how colorless a diamond is, with D being completely colorless.',
    carat: 'Carat',
    caratDesc: 'Carat measures the weight of the diamond, with one carat equal to 200 milligrams.',
    gradingScale: 'Grading Scale:',
    testKnowledge: 'Test Your Knowledge',
    testDescription: 'See how well you understand the 4Cs!',
    quizComplete: 'Quiz Complete!',
    yourScore: 'You scored',
    correctAnswers: 'Correct Answers:',
    greatJob: 'Great job learning about diamond quality!',
    nextCutting: 'Next: Cutting & Polishing',

    // Quiz Questions
    quiz1: 'Which \'C\' affects a diamond\'s sparkle the most?',
    quiz1Options: ['Cut', 'Color', 'Clarity', 'Carat'],
    quiz2: 'What does \'FL\' mean in diamond clarity?',
    quiz2Options: ['Flawed', 'Flawless', 'Fair Light', 'Fine Luster'],
    quiz3: 'Which color grade represents a completely colorless diamond?',
    quiz3Options: ['A', 'D', 'F', 'Z'],

    // Cutting Section
    cuttingTitle: 'Cutting & Polishing',
    cuttingDescription: 'The art of transforming rough diamonds into brilliant gems through precision cutting and polishing.',
    interactiveDiamond: 'Interactive Diamond',
    adjustQuality: 'Adjust the cut quality to see how it affects brilliance',
    cutQuality: 'Cut Quality',
    diamondShapes: 'Diamond Shapes',
    brilliance: 'Brilliance',
    poor: 'Poor',
    fair: 'Fair',
    good: 'Good',
    veryGood: 'Very Good',
    excellent: 'Excellent',
    poorDesc: 'Light leaks out, minimal sparkle',
    fairDesc: 'Some light return, modest sparkle',
    goodDesc: 'Good light return, nice sparkle',
    veryGoodDesc: 'Excellent light return, bright sparkle',
    excellentDesc: 'Maximum light return, exceptional sparkle',
    cuttingProcess: 'The Cutting Process',
    planning: 'Planning: Analyzing the rough diamond to maximize yield',
    cleaving: 'Cleaving: Splitting the diamond along natural grain lines',
    shaping: 'Shaping: Creating the basic outline of the final shape',
    polishing: 'Polishing: Creating precise facets for maximum brilliance',
    nextCertification: 'Next: Certification',

    // Certification Section
    certificationTitle: 'Diamond Certification',
    certificationDescription: 'Independent verification ensures quality, authenticity, and value for your diamond investment.',
    gradingReport: 'Diamond Grading Report',
    certificateNumber: 'Certificate #',
    verified: 'Verified',
    diamondDetails: 'Diamond Details',
    measurements: 'Measurements',
    shape: 'Shape',
    caratWeight: 'Carat Weight',
    colorGrade: 'Color Grade',
    clarityGrade: 'Clarity Grade',
    cutGrade: 'Cut Grade',
    dimensions: 'Dimensions',
    table: 'Table',
    depth: 'Depth',
    girdle: 'Girdle',
    fluorescence: 'Fluorescence',
    certificateGuarantee: 'This certificate guarantees the authenticity and quality of your diamond',
    trustedBodies: 'Trusted Certification Bodies',
    faq: 'Frequently Asked Questions',
    nextJourney: 'Next: Journey to You',

    // Journey Section
    journeyTitle: 'Journey to Your Heart',
    journeyDescription: 'From our hands to yours - every diamond carries a story of love, commitment, and dreams come true.',
    diamondJourney: 'Your Diamond\'s Journey',
    orderConfirmation: 'Order Confirmation',
    orderConfirmed: 'Your order is confirmed and being prepared',
    qualityInspection: 'Quality Inspection',
    finalCheck: 'Final quality check and secure packaging',
    shipped: 'Shipped',
    onWay: 'Your diamond is on its way to you',
    delivered: 'Delivered',
    arrives: 'Your precious diamond arrives safely',
    storiesOfLove: 'Stories of Love',
    moreThanDiamond: 'More Than Just a Diamond',
    moreThanDescription: 'Every diamond we deliver carries with it the promise of forever. From the moment it leaves our hands to the moment it reaches yours, it\'s not just a precious stone - it\'s a symbol of love, commitment, and the beginning of your unique story.',
    satisfactionGuarantee: 'Satisfaction Guarantee',
    lifetimeSupport: 'Lifetime Care & Support',
    foreverMemories: 'Forever Memories Created',
    completeJourney: 'Complete Your Journey',
    
    // Ginza Diamond Shiraishi translations
    ginzaDiamondTitle1: 'Affordable Prices, High-Quality Diamonds',
    ginzaDiamondContent1: 'GINZA DIAMOND SHIRAISHI selects world-class diamonds from the world\'s three major diamond markets (India, Israel, Belgium) through its own strict selection and procurement system, ensuring they are offered at reasonable prices. We maintain a stock of over 18,000 diamonds, each strictly inspected for details such as cutting angles and transparency, far exceeding traditional 4C standards to ensure they exhibit a brilliance that surpasses what can be measured by certification alone.',
    ginzaDiamondContent2: 'Since its establishment, GINZA DIAMOND SHIRAISHI has consistently provided "First-hand Diamonds (Virgin Diamonds)" suitable for life\'s important moments, as well as diamonds with world-class brilliance. We continuously pursue the highest quality and pass this commitment on to every couple, making their happy moments even more radiant.',
    ginzaDiamondTitle2: 'The Commitment to "First-hand Diamonds"',
    ginzaDiamondContent3: 'GINZA DIAMOND SHIRAISHI purchases rough diamonds directly from rough stone holders in the world\'s three major diamond markets (India, Israel, Belgium) and commissions exclusive grinding factories for precision cutting and polishing. All diamonds undergo strict screening and the brand independently handles everything from procurement to sales in a one-stop operation. We consistently provide "First-hand Diamonds (Virgin Diamonds)" to ensure they possess the world\'s highest level of brilliance.',
    ginzaDiamondContent4: 'Through this one-stop operation, we ensure all diamonds are not "Conflict Diamonds," and are definitely not "Second-hand Diamonds" or "Recycled Diamonds." All diamonds comply with the "Kimberley Process Certification Scheme" and are truly pure and flawless first-hand diamonds. This unique and distinctive diamond procurement mechanism allows GINZA DIAMOND SHIRAISHI to provide high-quality first-hand diamonds that have never been worn by others, truly belonging to couples. We closely monitor global market trends, economic conditions, and exchange rate fluctuations to ensure we offer the highest quality diamonds at the most reasonable prices, allowing every couple\'s love story to shine with pure brilliance. This is the brand commitment and persistence that GINZA DIAMOND SHIRAISHI takes the greatest pride in.',
    ginzaDiamondTitle3: 'Strictly Screening Every Diamond, Careful Procurement',
    ginzaDiamondContent5: 'We carefully select and procure precision-ground diamonds from the world\'s three major diamond markets (India, Israel, Belgium) and measure their brilliance performance one by one using the Sarine Light system. We only select top-grade diamonds that meet our buyers\' strict standards and achieve the highest Ultimate rating, ensuring each diamond possesses极致璀璨的光芒.',
    ginzaDiamondTitle4: 'First-hand Diamond Certificate',
    ginzaDiamondContent6: 'GINZA DIAMOND SHIRAISHI wants every customer to be able to choose diamonds with confidence, so we specially provide a "First-hand Diamond Certificate (Virgin Diamond Certificate)".',
    ginzaDiamondContent7: 'Under current international circumstances, "First-hand Diamonds" are no longer a matter of course. However, the diamonds provided by GINZA DIAMOND SHIRAISHI are not only guaranteed not to be "Conflict Diamonds," but also strictly ensure that no "Second-hand Diamonds" or "Recut Diamonds" are used, with each diamond being precious and pure first-hand diamonds. Through this certificate, we commit to providing customers with truly rare and pure diamonds, allowing every couple to possess the precious brilliance for the most important moments in their lives.',

    // Conclusion Section - Updated translations to match Chinese content
    conclusionTitle: 'Begin Your Story',
    conclusionDescription: 'Your diamond journey starts here. Let us help you find the perfect symbol of your love story that will shine for generations to come.',
    exploreCollection: 'Engagement Ring',
    browseSelection: 'To make the love between two people shine eternally, we provide top-quality premium diamonds. Meet your one-of-a-kind destined diamond at Ginza Diamond Shiraishi.',
    shopNow: 'Select Your Favorite Ring',
    bookConsultation: 'Wedding Ring',
    meetExperts: 'Wedding rings that need to be worn for long periods in daily life after marriage - comfort and durability are the craftsmanship constantly pursued and researched by Ginza Diamond Shiraishi.',
    scheduleNow: 'Select Your Favorite Ring',
    customDesign: 'Matching Set',
    createUnique: 'Ginza Diamond Shiraishi\'s matching sets are designed with a sense of ensemble to suit daily wear, just like a complete set.',
    startDesigning: 'Select Your Favorite Ring',
    stayConnected: 'Stay Connected',
    exclusiveAccess: 'Get exclusive access to new collections, diamond education, and special offers.',
    subscribeNewsletter: 'Subscribe to Newsletter',
    thankYouSubscribing: 'Thank you for subscribing!',
    receiveUpdates: 'You\'ll receive our latest updates soon.',
    getInTouch: 'Get in Touch',
    shareJourney: 'Share Your Journey',
    thankYouJoining: 'Thank You for Joining Our Journey',
    finalMessage: 'From the depths of the Earth to the sparkle in your eyes, every diamond carries a story of time, pressure, and transformation. Now it\'s time to create your own story.'
  },
  'ja': {
    // Navigation
    hero: 'ダイヤモンドの美しさ',
    mine: 'ダイヤモンド鉱山',
    grading: '選別とグレーディング',
    cutting: 'カットと研磨',
    certification: '認証',
    journey: 'お客様への旅',
    conclusion: 'あなたのダイヤモンドの旅',

    // Hero Section
    heroTitle: '永遠の輝きの',
    heroSubtitle: '旅路',
    heroDescription: '原石から輝く宝石への非凡な旅を発見してください。それぞれのダイヤモンドは何十億年の物語を語ります。',
    beginJourney: '旅を始める',

    // Mine Section
    mineTitle: 'ダイヤモンド鉱山',
    mineDescription: '地球の表面の深く、自然の最も貴重な宝物が発見を待っています。ダイヤモンド採掘の魅力的な世界を探索してください。',
    extraction: '採掘',
    extractionDesc: 'ダイヤモンドは先進的な採掘技術を使用して地球の深部から抽出されます。',
    extractionDetails: '露天掘りと地下採掘の方法がダイヤモンドを含む鉱石堆積物に到達するために使用されます。',
    processing: '処理',
    processingDesc: '原鉱石は処理されて、周囲の岩石や鉱物からダイヤモンドを分離します。',
    processingDetails: 'X線技術と重液分離がダイヤモンドの識別と抽出を支援します。',
    recovery: '回収',
    recoveryDesc: '先進技術により、処理された鉱石からの最大のダイヤモンド回収を確保します。',
    recoveryDetails: '高度な選別システムは直径1mmという小さなダイヤモンドも検出できます。',
    didYouKnow: 'ご存知ですか？',
    diamondFormation: 'ダイヤモンドは地球表面の100-200キロメートル下で極度の圧力と温度の下で形成されます。ダイヤモンドが自然に形成されるには何十億年もかかります！',
    nextSorting: '次へ：選別とグレーディング',

    // Earth Layers
    surfaceLayer: '表面層',
    continentalCrust: '大陸地殻',
    upperMantle: '上部マントル',
    lowerMantle: '下部マントル',
    coreMantle: 'コア・マントル境界',

    // Grading Section
    gradingTitle: 'ダイヤモンドの4C',
    gradingDescription: 'ダイヤモンドの品質と価値を決定する4つの特性を理解しましょう。',
    exploreCharacteristics: '各特性を探る',
    cut: 'カット',
    cutDesc: 'カットはダイヤモンドが光をどれだけよく反射するかを決定し、その輝きと煌めきに影響します。',
    clarity: 'クラリティ',
    clarityDesc: 'クラリティはダイヤモンド内のインクルージョンや傷の欠如を測定します。',
    color: 'カラー',
    colorDesc: 'カラーはダイヤモンドがどれだけ無色かを等級付けし、Dが完全に無色です。',
    carat: 'カラット',
    caratDesc: 'カラットはダイヤモンドの重量を測定し、1カラットは200ミリグラムに等しいです。',
    gradingScale: 'グレーディングスケール：',
    testKnowledge: '知識をテスト',
    testDescription: '4Cをどれだけよく理解しているか確認しましょう！',
    quizComplete: 'クイズ完了！',
    yourScore: 'あなたのスコア',
    correctAnswers: '正解：',
    greatJob: 'ダイヤモンドの品質について学習、素晴らしいです！',
    nextCutting: '次へ：カットと研磨',

    // Quiz Questions
    quiz1: 'どの「C」がダイヤモンドの煌めきに最も影響しますか？',
    quiz1Options: ['カット', 'カラー', 'クラリティ', 'カラット'],
    quiz2: 'ダイヤモンドクラリティの「FL」は何を意味しますか？',
    quiz2Options: ['欠陥あり', 'フローレス', 'フェアライト', 'ファインラスター'],
    quiz3: 'どのカラーグレードが完全に無色のダイヤモンドを表しますか？',
    quiz3Options: ['A', 'D', 'F', 'Z'],

    // Cutting Section
    cuttingTitle: 'カットと研磨',
    cuttingDescription: '精密なカットと研磨を通じて粗いダイヤモンドを輝く宝石に変える芸術。',
    interactiveDiamond: 'インタラクティブダイヤモンド',
    adjustQuality: 'カット品質を調整して輝きへの影響を見る',
    cutQuality: 'カット品質',
    diamondShapes: 'ダイヤモンドシェイプ',
    brilliance: '輝き',
    poor: 'プア',
    fair: 'フェア',
    good: 'グッド',
    veryGood: 'ベリーグッド',
    excellent: 'エクセレント',
    poorDesc: '光の漏れが多く、輝きが最小限',
    fairDesc: '一部の光の反射、控えめな輝き',
    goodDesc: '良好な光の反射、良い輝き',
    veryGoodDesc: '優秀な光の反射、明るい輝き',
    excellentDesc: '最大の光の反射、卓越した輝き',
    cuttingProcess: 'カッティングプロセス',
    planning: '計画：粗いダイヤモンドを分析して収量を最大化',
    cleaving: '劈開：自然な結晶線に沿ってダイヤモンドを分割',
    shaping: '成形：最終形状の基本輪郭を作成',
    polishing: '研磨：最大の輝きのための精密なファセットを作成',
    nextCertification: '次へ：認証',

    // Certification Section
    certificationTitle: 'ダイヤモンド認証',
    certificationDescription: '独立検証により、あなたのダイヤモンド投資の品質、真正性、価値を保証します。',
    gradingReport: 'ダイヤモンドグレーディングレポート',
    certificateNumber: '証明書番号',
    verified: '検証済み',
    diamondDetails: 'ダイヤモンドの詳細',
    measurements: '測定値',
    shape: 'シェイプ',
    caratWeight: 'カラット重量',
    colorGrade: 'カラーグレード',
    clarityGrade: 'クラリティグレード',
    cutGrade: 'カットグレード',
    dimensions: '寸法',
    table: 'テーブル',
    depth: 'デプス',
    girdle: 'ガードル',
    fluorescence: '蛍光性',
    certificateGuarantee: 'この証明書はあなたのダイヤモンドの真正性と品質を保証します',
    trustedBodies: '信頼できる認証機関',
    faq: 'よくある質問',
    nextJourney: '次へ：あなたへの旅',

    // Journey Section
    journeyTitle: 'あなたの心への旅',
    journeyDescription: '私たちの手からあなたの手へ - すべてのダイヤモンドは愛、約束、夢の実現の物語を運びます。',
    diamondJourney: 'あなたのダイヤモンドの旅',
    orderConfirmation: '注文確認',
    orderConfirmed: 'ご注文が確認され、準備中です',
    qualityInspection: '品質検査',
    finalCheck: '最終品質チェックと安全な梱包',
    shipped: '発送済み',
    onWay: 'あなたのダイヤモンドがお手元に向かっています',
    delivered: '配達完了',
    arrives: 'あなたの貴重なダイヤモンドが安全に到着',
    storiesOfLove: '愛の物語',
    moreThanDiamond: 'ただのダイヤモンド以上',
    moreThanDescription: '私たちが配達するすべてのダイヤモンドは永遠の約束を運んでいます。私たちの手を離れる瞬間からあなたの手に届く瞬間まで、それはただの貴重な石ではありません - それは愛、約束、そしてあなたのユニークな物語の始まりの象徴です。',
    satisfactionGuarantee: '満足保証',
    lifetimeSupport: '生涯ケア＆サポート',
    foreverMemories: '永遠の思い出の創造',
    completeJourney: 'あなたの旅を完成させる',
    
    // Ginza Diamond Shiraishi translations
    ginzaDiamondTitle1: '実惠の価格、高品質なダイヤモンド',
    ginzaDiamondContent1: 'GINZA DIAMOND SHIRAISHI（銀座白石）は、独自の厳格な選別および調達システムを通じて、世界三大ダイヤモンド市場（インド、イスラエル、ベルギー）から世界最高級の美ダイヤモンドを厳選し、適正価格で顧客に提供することを確約しています。当社は常時18,000石以上のダイヤモンドを保有しており、それぞれがカット角度や透明度などの詳細を厳しく検査し、従来の4C基準をはるかに超える品質を確保して、鑑定書では測定できない輝きを実現しています。',
    ginzaDiamondContent2: '創業以来、GINZA DIAMOND SHIRAISHI（銀座白石）は、人生の重要な瞬間としてふさわしい「ファーストハンドダイヤモンド（Virgin Diamond）」および世界最高級の輝きを持つ美ダイヤモンドを提供し続けています。私たちは常に最高品質の追求を怠らず、この堅持をすべてのカップルに伝え、彼らの幸せな瞬間をより輝かせることを実現しています。',
    ginzaDiamondTitle2: '「ファーストハンドダイヤモンド」への堅持',
    ginzaDiamondContent3: 'GINZA DIAMOND SHIRAISHI（銀座白石）は、世界三大ダイヤモンド市場（インド、イスラエル、ベルギー）の原石保有者から直接原石を調達し、専属の研磨工場に精密なカットと研磨を委託しています。すべてのダイヤモンドは厳格な選別を経ており、ブランドは調達から販売までの一貫した経営を独立して担当しています。私たちは常に「ファーストハンドダイヤモンド（Virgin Diamond）」を提供し、世界最高レベルの輝きを持つことを保証しています。',
    ginzaDiamondContent4: 'このような一貫した経営により、すべてのダイヤモンドが「コンフリクトダイヤモンド（Conflict Diamonds）」でなく、また「中古ダイヤモンド（Reuse Diamonds）」や「再カットダイヤモンド（Recycled Diamonds）」でもないことを厳守しています。すべてのダイヤモンドは「キンバーリープロセス認証制度（Kimberley Process Certification Scheme）」に適合し、真に純粋無欠なファーストハンドダイヤモンドです。この他とは異なる、独特なダイヤモンド調達メカニズムにより、GINZA DIAMOND SHIRAISHI（銀座白石）は他者に着用されたことがない、真にカップルに属する高品質なファーストハンドダイヤモンドを提供できます。私たちはグローバルな市場動向、経済環境、為替変動を密接に注視し、最も合理的な価格で、すべてのカップルに最高品質のダイヤモンドを提供し、彼らのラブストーリーが純粋な輝きを放つように努めています。これはGINZA DIAMOND SHIRAISHI（銀座白石）が最も誇りに思うブランドの約束と堅持です。',
    ginzaDiamondTitle3: '各ダイヤモンドを厳しく選別し、慎重に調達',
    ginzaDiamondContent5: '世界三大ダイヤモンド市場（インド、イスラエル、ベルギー）から厳選調達した精密研磨されたダイヤモンドを、Sarine Lightシステムで一つ一つその輝きの性能を測定しています。当社はバイヤーの厳格な基準を満たし、最高評価であるUltimateに達した最上級ダイヤモンドのみを選択し、それぞれが極致的な輝きを持つことを保証しています。',
    ginzaDiamondTitle4: 'ファーストハンドダイヤモンド証書',
    ginzaDiamondContent6: 'GINZA DIAMOND SHIRAISHI（銀座白石）は、すべての顧客が安心してダイヤモンドを選べるように、「ファーストハンドダイヤモンド証書（Virgin Diamond Certificate）」を特別に提供しています。',
    ginzaDiamondContent7: '今日の国際情勢の影響により、「ファーストハンドダイヤモンド」はもはや当然の選択ではありません。しかし、GINZA DIAMOND SHIRAISHI（銀座白石）が提供するダイヤモンドは、「コンフリクトダイヤモンド」でないことだけでなく、「中古ダイヤモンド」や「再カットダイヤモンド」を使用していないことを厳格に保証し、それぞれが貴重で純粋なファーストハンドダイヤモンドです。この証明を通じて、私たちは顧客に真に希少で純粋無欠なダイヤモンドを提供することを約束し、すべてのカップルが人生で最も重要な瞬間を持つための貴重な輝きを手に入れられるようにしています。',

    // Conclusion Section - Updated translations to match Chinese content
    conclusionTitle: 'あなたの物語を始める',
    conclusionDescription: 'あなたのダイヤモンドの旅はここから始まります。世代を超えて輝くあなたの愛の物語の完璧なシンボルを見つけるお手伝いをさせてください。',
    exploreCollection: 'プロポーズ指輪',
    browseSelection: '二人の愛を永遠に輝かせるために、最高品質のトップクラスのダイヤモンドを提供します。銀座白石であなただけの運命のダイヤモンドに出会ってください。',
    shopNow: '気に入った指輪を選ぶ',
    bookConsultation: '結婚指輪',
    meetExperts: '結婚後の日常生活で長時間着用する結婚指輪の快適性と耐久性は、銀座白石が絶えず追求し研究する工法です。',
    scheduleNow: '気に入った指輪を選ぶ',
    customDesign: 'マッチングリング',
    createUnique: '銀座白石のマッチングリングは、日常生活での着用に合わせて、まるでセットのような全体感デザインになっています。',
    startDesigning: '気に入った指輪を選ぶ',
    stayConnected: 'つながりを保つ',
    exclusiveAccess: '新しいコレクション、ダイヤモンド教育、特別オファーへの独占アクセスを取得。',
    subscribeNewsletter: 'ニュースレター購読',
    thankYouSubscribing: '購読いただきありがとうございます！',
    receiveUpdates: '最新情報をすぐにお届けします。',
    getInTouch: 'お問い合わせ',
    shareJourney: 'あなたの旅を共有',
    thankYouJoining: '私たちの旅にご参加いただきありがとうございます',
    finalMessage: '地球の深部からあなたの目の輝きまで、すべてのダイヤモンドは時間、圧力、変化の物語を運んでいます。今、あなた自身の物語を作る時です。'
  }
};

export const useTranslation = (language) => {
  const t = (key) => {
    return translations[language]?.[key] || translations['zh-TW'][key] || key;
  };
  return { t };
};